<template>
  <div class="headbar">
    <div class="nav">
      <div class="navLeft">
        <div class="logo">
          <img src="../assets/images/logo.png">
        </div>
        <div class="title">
            <p v-for="(item,index) in titleList" :key="index" @click="goOtherPage(item,index)" :class="current===item.id?'active':''">
              {{item.name}}
            </p>
        </div>
      </div>
      <div class="navRight">
        <img style="vertical-align: middle" src="../assets/images/Vector.png">
        <span style="color: white;font-weight: 600;font-size: 16px;margin-left: 20px">0871-63302042</span>
      </div>
      <!-- 汉堡按钮:仅 <768 显示 -->
      <button class="hamburger" :class="{open:menuOpen}" @click="menuOpen=!menuOpen" aria-label="菜单" aria-haspopup="true" :aria-expanded="menuOpen ? 'true':'false'">
        <span></span><span></span><span></span>
      </button>
    </div>
    <!-- 移动端下拉抽屉:仅 <768 -->
    <transition name="drawer">
      <div class="mobileMenu" v-show="menuOpen">
        <p v-for="(item,index) in titleList" :key="index" @click="goOtherPage(item,index)" :class="current===item.id?'active':''">
          {{item.name}}
        </p>
        <a class="m-phone" href="tel:087163302042">
          <img src="../assets/images/Vector.png"> 0871-63302042
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "headbar",
  data() {
    return {
      titleList:[
        {name:'首页',id:'1',path:'/'},
        {name:'行业',id:'2',path:'/trade'},
        {name:'产品',id:'3',path:'/product'},
        {name:'AI 产品',id:'5',path:'/ai'},
        {name:'关于我们',id:'4',path:'/aboutUs'},
      ],
      current:'1',
      menuOpen:false          // 移动端抽屉开关(唯一需要的交互状态)
    }
  },
  watch:{
    $route(to,from){
      this.menuOpen = false   // 路由切换即收起抽屉
      if(to.path==='/aboutUs'){
        this.current='4'
      }else if(to.path==='/trade'){
        this.current='2'
      }else if(to.path==='/product'){
        this.current='3'
      }else if(to.path==='/ai'){
        this.current='5'
      }else if(to.path==='/'){
        this.current='1'
      }else{
        this.current=''
      }
    }
  },
  mounted(){
  },
  methods: {
    goOtherPage(item,index){
      this.current=item.id
      this.menuOpen=false
      this.$router.push(item.path)
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.headbar {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;   /* 让抽屉排在导航条下方 */
  width: 100vw;
  background: rgba(255, 255, 255, 0.2);
}
.nav {
  margin: 0 auto;
  width: min(1400px, 100% - 40px);   /* 流式容器:桌面封顶 1400,小屏留 20px 双边 */
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navLeft {
  box-sizing: border-box;
  width: 660px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navLeft .title{
  width: 420px;
  color: white;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
}
.navLeft .title p{
  white-space: nowrap;
}
.navLeft .logo {
  height: 42px;
  display: flex;
  align-items: center;
}
.navLeft .logo img{ height: 42px; }
.navLeft .title p{
  cursor: pointer;
  font-weight: 500;
}
.navRight{ display:flex; align-items:center; }
.active{
 color:#0487E3
}

/* 汉堡按钮:默认藏,<768 显示 */
.hamburger{
  display:none;
  width:30px; height:24px; position:relative;
  background:none; border:0; cursor:pointer; padding:0;
}
.hamburger span{
  position:absolute; left:0; height:3px; width:100%;
  background:#fff; border-radius:3px; transition:transform .3s, opacity .2s, top .3s;
}
.hamburger span:nth-child(1){ top:0; }
.hamburger span:nth-child(2){ top:10.5px; }
.hamburger span:nth-child(3){ top:21px; }
.hamburger.open span:nth-child(1){ top:10.5px; transform:rotate(45deg); }
.hamburger.open span:nth-child(2){ opacity:0; }
.hamburger.open span:nth-child(3){ top:10.5px; transform:rotate(-45deg); }

/* 移动抽屉 */
.mobileMenu{ display:none; }

/* ============ 移动端 (<768) ============ */
@media (max-width:768px){
  .navLeft{ width:auto; }
  .navLeft .title{ display:none; }   /* 隐藏横排链接 */
  .navRight{ display:none; }          /* 电话移入抽屉 */
  .hamburger{ display:block; }

  .mobileMenu{
    display:flex; flex-direction:column;
    width:100%;
    background:rgba(20,40,70,.92);
    backdrop-filter:blur(10px);
    -webkit-backdrop-filter:blur(10px);
    padding:8px 0;
  }
  .mobileMenu p{
    color:#fff; font-size:16px; font-weight:500;
    padding:14px 24px; cursor:pointer;
    border-top:1px solid rgba(255,255,255,.12);
  }
  .mobileMenu p.active{ color:#54B8FF; }
  .m-phone{
    display:flex; align-items:center; gap:10px;
    color:#fff; font-weight:600; font-size:16px; text-decoration:none;
    padding:16px 24px; border-top:1px solid rgba(255,255,255,.12);
  }
  .m-phone img{ height:18px; }

  /* 抽屉展开动画 */
  .drawer-enter-active,.drawer-leave-active{ transition:opacity .25s, transform .25s; }
  .drawer-enter-from,.drawer-leave-to{ opacity:0; transform:translateY(-8px); }
}
</style>
